import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', path: '/' },
  { label: '恋爱言情', path: '/category/romance' },
  { label: '奇幻冒险', path: '/category/fantasy' },
  { label: '热血动作', path: '/category/action' },
  { label: '悬疑惊悚', path: '/category/thriller' },
  { label: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 80);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <nav className="flex items-center justify-between px-6 md:px-10 py-4 max-w-[1440px] mx-auto" aria-label="主导航">
        <Link to="/" className="flex items-center gap-2">
          <div className={`font-heading text-xl md:text-2xl font-bold whitespace-nowrap transition-colors duration-500 ${
            isScrolled ? 'text-foreground-950' : 'text-white'
          }`}>
            韩国漫画网
          </div>
        </Link>

        {/* Desktop nav links */}
        <ul className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <li key={link.path}>
              <Link
                to={link.path}
                className={`text-sm font-medium whitespace-nowrap transition-colors duration-300 hover:text-accent-500 ${
                  isScrolled
                    ? 'text-foreground-700'
                    : 'text-white/90'
                } ${
                  location.pathname === link.path
                    ? isScrolled ? '!text-primary-500' : '!text-accent-500'
                    : ''
                }`}
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>

        {/* Desktop right actions */}
        <div className="hidden md:flex items-center gap-4">
          <Link
            to="/category/romance"
            className={`whitespace-nowrap px-5 py-2 rounded-full border text-sm font-medium transition-all duration-300 cursor-pointer ${
              isScrolled
                ? 'border-primary-500 text-primary-500 hover:bg-primary-500 hover:text-background-50'
                : 'border-white/60 text-white hover:bg-white hover:text-foreground-950'
            }`}
          >
            开始阅读
          </Link>
        </div>

        {/* Mobile hamburger */}
        <button
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer transition-colors ${
            isScrolled ? 'text-foreground-950' : 'text-white'
          }`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label={mobileOpen ? '关闭菜单' : '打开菜单'}
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <ul className="flex flex-col px-6 py-4 gap-3">
            {navLinks.map((link) => (
              <li key={link.path}>
                <Link
                  to={link.path}
                  className={`block py-2 text-base font-medium whitespace-nowrap ${
                    location.pathname === link.path
                      ? 'text-primary-500'
                      : 'text-foreground-700'
                  }`}
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}